import React from 'react'
import { useSelector } from 'react-redux'
import './style.scss'
import { BASE_DEV_URL, BASE_URL } from '../../config/api.config'
import { toastr } from 'react-redux-toastr'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { IonContent, IonHeader, IonPage } from '@ionic/react'
import Toolbar from '../../components/Toolbar/Toolbar'

const ReferCode = () => {
  const width = window.innerWidth
  const token = localStorage.getItem('id_token')
  const promotions = useSelector((state) => state.promotions.socials)

  const [bonusSetting, setBonusSetting] = useState()

  const fetchAffBonusSetting = async () => {
    try {
      const res = await axios.post(
        `${BASE_DEV_URL}report/getUserAffCode`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (res?.data) {
        setBonusSetting(res?.data?.data)
      }
    } catch (error) {
      console.error('Error fetching bonus setting:', error)
    }
  }

  useEffect(() => {
    fetchAffBonusSetting()
  }, [])

  const affiliateLink = `${BASE_URL}/default-page?referCode=${bonusSetting?.refer_code}`

  const whatsappUrl = promotions?.Whatsapp?.url
  const instapUrl = promotions?.Instagram?.url

  const updatedWhatsappUrl = whatsappUrl
    ? whatsappUrl.replace(
        /text=[^&]*/g,
        `text=${encodeURIComponent(affiliateLink)}`
      )
    : null

  const telegramShareUrl = `https://t.me/share/url?url=${encodeURIComponent(
    affiliateLink
  )}&text=${encodeURIComponent(affiliateLink)}`

  const copyAffiliateLink = () => {
    const link = `${BASE_URL}/default-page?referCode=${bonusSetting?.refer_code}`
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toastr.success('', 'Link copied to clipboard!')
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
      })
  }
  const copyAffiliateCode = (refer_code) => {
    navigator.clipboard
      .writeText(refer_code)
      .then(() => {
        toastr.success('', 'Code copied to clipboard!')
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
      })
  }

  if (width < 1024) {
    return (
      <IonPage>
        <IonHeader>
          <Toolbar />
        </IonHeader>
        <IonContent className="account-statement-page" fullscreen>
          <div
            className="w-full md:mt-[0px]   lg:overflow-auto lg:w-[54%]"
            style={{ minHeight: 'calc(-110px + 100dvh)' }}
          >
            <div className="cricket-wrapper rewards-wrapper pb-2">
              <div className=" p-2">
                <div className="no-notifucation-icon w-full flex justify-center p-2  text-center">
                  <img
                    loading="lazy"
                    src="/bonus/gift-boxs.svg"
                    alt="gift-box"
                    className="block"
                  />
                </div>

                <div className="thm-heading d-block text-center ">
                  <h3 className="font-semibold">Refer and Rewards.</h3>
                  <p className="text-sm">
                    Copy your code, share it with your friends.
                  </p>
                </div>

                <div className="thm-heading d-block">
                  <span className="">Your Referral Code:</span>
                </div>

                <div className="referandearn-main copy-input-sec relative mb-2">
                  <input
                    type="text"
                    placeholder={bonusSetting?.refer_code}
                    disabled=""
                  />
                  <button
                    className="thm-but cpy-btn"
                    onClick={() => copyAffiliateCode(bonusSetting?.refer_code)}
                  >
                    Copy
                  </button>
                </div>

                <div className="number-sec my-3">
                  {(promotions?.Whatsapp?.is_active ||
                    promotions?.Telegram?.is_active ||
                    promotions?.Instagram?.is_active) && (
                    <div className="af-share-link-wrapper">
                      <div className="affilate-cmn-footer">
                        <div className="shre-text-title">
                          <p className="text-2xl font-semibold">
                            Share this link via
                          </p>
                        </div>

                        <div className="af-share-social-link-sec">
                          {promotions?.Whatsapp?.is_active && (
                            <a
                              href={updatedWhatsappUrl}
                              target="_blank"
                              className=""
                            >
                              <img src="/what.webp" alt="whatsapp" />
                            </a>
                          )}

                          {promotions?.Telegram?.is_active && (
                            <a href={telegramShareUrl} target="_blank">
                              <img
                                src="/instagram-share.svg"
                                alt="instagram-share"
                              />
                            </a>
                          )}

                          {promotions?.Instagram?.is_active && (
                            <a href={instapUrl} target="_blank">
                              <img
                                src="/telegram-share.svg"
                                alt="telegram-share"
                              />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="refer-link my-3">
                  <h5 className="text-capitalize">Refer Link</h5>

                  <div className="referandearn-main copy-input-sec relative">
                    <input
                      type="text"
                      placeholder={`${BASE_URL}/default-page?referCode=${bonusSetting?.refer_code}`}
                      disabled=""
                    />
                    <button
                      className="thm-but cpy-btn"
                      onClick={copyAffiliateLink}
                    >
                      Copy
                    </button>
                  </div>
                </div>

                <div className="container">
                  <div className="thm-heading maximum-p d-block">
                    <p className="text-sm font-semibold">
                      <span className="team-list-wet">Note : </span>
                      Maximum bonus you can receive for Referral Bonus is{' '}
                      <b> 0</b>. {/* Value from API */}
                      Referral apply on every wallet deposit.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </IonContent>
      </IonPage>
    )
  }

  return (
    <div
      className="w-full md:mt-[0px]   lg:overflow-auto lg:w-[54%]"
      style={{ minHeight: 'calc(-110px + 100dvh)' }}
    >
      <div className="cricket-wrapper rewards-wrapper pb-2">
        <div className=" p-2">
          <div className="no-notifucation-icon w-full flex justify-center p-2  text-center">
            <img
              loading="lazy"
              src="/bonus/gift-boxs.svg"
              alt="gift-box"
              className="block"
            />
          </div>

          <div className="thm-heading d-block text-center ">
            <h3 className="font-semibold">Refer and Rewards.</h3>
            <p className="text-sm">
              Copy your code, share it with your friends.
            </p>
          </div>

          <div className="thm-heading d-block">
            <span className="">Your Referral Code:</span>
          </div>

          <div className="referandearn-main copy-input-sec relative mb-2">
            <input
              type="text"
              placeholder={bonusSetting?.refer_code}
              disabled=""
            />
            <button
              className="thm-but cpy-btn"
              onClick={() => copyAffiliateCode(bonusSetting?.refer_code)}
            >
              Copy
            </button>
          </div>

          <div className="number-sec my-3">
            {(promotions?.Whatsapp?.is_active ||
              promotions?.Telegram?.is_active ||
              promotions?.Instagram?.is_active) && (
              <div className="af-share-link-wrapper">
                <div className="affilate-cmn-footer">
                  <div className="shre-text-title">
                    <p className="text-2xl font-semibold">
                      Share this link via
                    </p>
                  </div>

                  <div className="af-share-social-link-sec">
                    {promotions?.Whatsapp?.is_active && (
                      <a href={updatedWhatsappUrl} target="_blank" className="">
                        <img src="/what.webp" alt="whatsapp" />
                      </a>
                    )}

                    {promotions?.Telegram?.is_active && (
                      <a href={telegramShareUrl} target="_blank">
                        <img src="/instagram-share.svg" alt="instagram-share" />
                      </a>
                    )}

                    {promotions?.Instagram?.is_active && (
                      <a href={instapUrl} target="_blank">
                        <img src="/telegram-share.svg" alt="telegram-share" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="refer-link my-3">
            <h5 className="text-capitalize">Refer Link</h5>

            <div className="referandearn-main copy-input-sec relative">
              <input
                type="text"
                placeholder={`${BASE_URL}/default-page?referCode=${bonusSetting?.refer_code}`}
                disabled=""
              />
              <button className="thm-but cpy-btn" onClick={copyAffiliateLink}>
                Copy
              </button>
            </div>
          </div>

          <div className="container">
            <div className="thm-heading maximum-p d-block">
              <p className="text-sm font-semibold">
                <span className="team-list-wet">Note : </span>
                Maximum bonus you can receive for Referral Bonus is <b> 0</b>.
                Referral apply on every wallet deposit.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReferCode
